<template lang="html">
  <span class="inline-flex items-center gap-0.5" role="img" :aria-label="label">
    <!-- Звезда — inline SVG (см. config/star.ts): UIcon рисуется маской и не закрашивается -->
    <svg
      v-for="i in 5"
      :key="i"
      viewBox="0 0 24 24"
      aria-hidden="true"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :fill="i <= filled ? 'currentColor' : 'none'"
      :class="[sizeClass, i <= filled ? 'text-primary' : 'text-dimmed']"
    >
      <path :d="STAR_PATH" />
    </svg>
  </span>
</template>

<script setup lang="ts">
import { STAR_PATH } from '../config/star'
import { filledStarsCount, ratingAriaLabel } from '../utils/reviewsFormat'

const props = withDefaults(
  defineProps<{
    /** Оценка 0–5 (средняя — дробная); null/undefined — «нет оценок» */
    value?: number | null
    size?: 'xs' | 'sm' | 'md'
  }>(),
  { value: 0, size: 'sm' },
)

const SIZE_CLASSES = { xs: 'size-3', sm: 'size-4', md: 'size-5' } as const

const filled = computed(() => filledStarsCount(props.value))
const label = computed(() => ratingAriaLabel(props.value))
const sizeClass = computed(() => SIZE_CLASSES[props.size])
</script>
